var map = {
	"./admin_settings.png": 1722,
	"./catalog.png": 1723,
	"./catalogWhite.png": 1724,
	"./catalog_orders.png": 1725,
	"./cms.png": 1726,
	"./component-fields/Asset.png": 1727,
	"./component-fields/Blocks.png": 1728,
	"./component-fields/Boolean.png": 1729,
	"./component-fields/Date-time.png": 1730,
	"./component-fields/LInk.png": 1731,
	"./component-fields/Markdown.png": 1732,
	"./component-fields/Multi asset.png": 1733,
	"./component-fields/Multi options.png": 1734,
	"./component-fields/Number.png": 1735,
	"./component-fields/Richtext.png": 1736,
	"./component-fields/Single options.png": 1737,
	"./component-fields/Table.png": 1738,
	"./component-fields/Text area.png": 1739,
	"./component-fields/Text.png": 1740,
	"./components.png": 1741,
	"./configuration.png": 1742,
	"./contents.png": 1743,
	"./crm.png": 1744,
	"./custom_order.png": 1745,
	"./customer_credits.png": 1746,
	"./customer_list.png": 1747,
	"./dashboard.png": 1748,
	"./finance.png": 1749,
	"./home.png": 1750,
	"./integrations.png": 1751,
	"./inventory-transfers.png": 1752,
	"./invoice-list.png": 1753,
	"./layaway.png": 1754,
	"./move.png": 1755,
	"./new_sale.png": 1756,
	"./orders.png": 1757,
	"./outgoing-consignments.png": 1758,
	"./payment-methods/amex.png": 1126,
	"./payment-methods/discover.png": 1125,
	"./payment-methods/mastercard.png": 1124,
	"./payment-methods/visa.png": 1123,
	"./payments.png": 1759,
	"./plus.png": 1346,
	"./register.png": 1760,
	"./repair_center.png": 1761,
	"./reports.png": 1762,
	"./services.png": 1763,
	"./trade_in_center.png": 1764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1392;